// The two paths Meta's checkout host returns the browser to (#3454).
//
// These are an EXTERNAL CONTRACT, not an internal routing detail. The absolute
// URLs built from them are registered on the APNB app row (#3446), and the
// completion redirect is matched against a prefix declared Meta-side
// (`https://console.dev.dreamwrite.com/`, D118981624). Renaming a path here
// without a matching change on the app row does not 404 — the redirect simply
// fails to match and the user is stranded on Meta's host.
//
// They live in one constant so the value we register is the value we route, and
// so the list of URLs to hand APNB can be derived rather than retyped.

// Spelled with an explicit readonly interface rather than `as const`: a const
// assertion is an `AsExpression` to the TypeScript AST, and the repo's
// forbidden-syntax check rejects every one of those.
interface CheckoutReturnPaths {
  readonly success: string
  readonly failure: string
}

export const CHECKOUT_RETURN_PATHS: CheckoutReturnPaths = {
  success: '/checkout/success',
  failure: '/checkout/failure',
}

/** The absolute URLs to register for a given console origin. */
export function checkoutReturnUrls(origin: string): { success: string; failure: string } {
  const base = origin.replace(/\/+$/, '')
  return {
    success: `${base}${CHECKOUT_RETURN_PATHS.success}`,
    failure: `${base}${CHECKOUT_RETURN_PATHS.failure}`,
  }
}
